import { VehicleCategory } from "models/VehicleCategory";
import { VehicleCategoryData } from "models/types";
import { BaseServices } from "./baseServices";

export class VehicleCategoryService extends BaseServices<VehicleCategoryData, VehicleCategory> {
	constructor() {
		super(VehicleCategory);
	}

	async listAll() {
		return this.list("vehicle-categories");
	}

	static getInstance() {
		return new VehicleCategoryService();
	}
}
